import { jsx as o } from "react/jsx-runtime";
import t from "../NotFoundMessage/NotFoundMessage.js";
import { NotFoundMessageType as e } from "../NotFoundMessage/NotFoundMessage.utils.js";
const n = () => /* @__PURE__ */ o(t, { type: e.UNIT });
export {
  n as default
};
//# sourceMappingURL=UnitNotFound.js.map
